export function getEstDaysRemaining(cancelledAt: Date | string): number {
  function toEstDayOffset(date: Date): number {
    const parts = new Intl.DateTimeFormat("en-US", {
      day: "numeric",
      month: "numeric",
      timeZone: "America/New_York",
      year: "numeric",
    }).formatToParts(date);
    const y = Number(parts.find((p) => p.type === "year")!.value);
    const m = Number(parts.find((p) => p.type === "month")!.value);
    const d = Number(parts.find((p) => p.type === "day")!.value);

    return Date.UTC(y, m - 1, d) / 86_400_000;
  }

  return toEstDayOffset(new Date(cancelledAt)) - toEstDayOffset(new Date());
}
